import { render } from "./copyable-contact.vue?vue&type=template&id=03904e1d"
import script from "./copyable-contact.vue?vue&type=script&lang=js"
export * from "./copyable-contact.vue?vue&type=script&lang=js"

import exportComponent from "F:\\code\\suplasercut\\suplasercut-admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__